import InfoIcon from "./infoIcon";

export const Info = InfoIcon;